import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';

import isEmail from 'app/forms/validations/isEmail';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const TASK_COPY_EMAIL_FORM = 'taskCopyEmail-form';

const { email } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	email,
};

export default () => ({
	[FIELDS.email]: {
		deepPath: [FIELDS.email],
		validations: [isRequired(), isEmail()],
	},
});
